// extracted by mini-css-extract-plugin
export var label = "_44-1";
export var reminder = "_44-0";